// @flow

import Loadable from "react-loadable";
import DynamicImportLoader from "app/components/atoms/DynamicImportLoader/DynamicImportLoader";
import type { InteractivesMenuItemConfig } from "../interactives-list";
import { ALL_USER_GROUPS_BUT_GUESTS } from "../../utils/constants";
import DisplayImage from "./image.png";

const description =
  "An invitation for readers to send insight, tips and images to our reporters.";
const CONFIG: InteractivesMenuItemConfig = {
  name: "Tipstar",
  id: "tipstar",
  groupsWithAccess: ALL_USER_GROUPS_BUT_GUESTS,
  linkPrefix: "/interactives",
  tags: ["Configurable", "Recorded input"],
  description,
  image: DisplayImage,
  // cradleIframeUrlRoot:"http://localhost:3000/?resizable=true",
  cradleIframeUrlRoot:"https://www.smh.com.au/interactive/modules/tip-jar/?resizable=true",
  ConfigComponent: Loadable({
    delay: 0, // See 'Avoiding Flash Of Loading Component': https://github.com/jamiebuilds/react-loadable
    loader: () =>
      import(/* webpackChunkName: "TipstarConfigTool" */ "app/components/tools/TipstarConfigTool/TipstarConfigTool"),
    loading: DynamicImportLoader,
    modules: ["TipstarConfigTool"]
  })
};

export default CONFIG;
